import { FormState } from '@vtex/admin-ui-form'
import { useAudiences } from 'hooks'
import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import { Item } from 'typings'
import { MultiSelect, searchItems } from 'ui'
import { messages } from './messages'

type Props = {
  name: string
  form: FormState
}

const MAX_OPTIONS = 10

export function AudienceSelector(props: Props) {
  const { name, form } = props

  const { $t } = useIntl()

  const [searchTerm, setSearchTerm] = useState<string>('')

  const { data, isLoading } = useAudiences()

  const options = useMemo<Item[]>(
    () => searchItems(data, searchTerm).slice(0, MAX_OPTIONS),
    [data, searchTerm]
  )

  return (
    <MultiSelect
      name={name}
      state={form}
      options={options}
      loading={isLoading}
      label={$t(messages.editor.label)}
      maxEntries={LIMITS.MAX_AUDIENCES}
      renderTag={({ name }) => name}
      renderOption={({ name }) => name}
      onSearch={setSearchTerm}
    />
  )
}
